<template>
  <ClientOnly>
 
    <div
  v-if="!cookiesSet"
  class="cookie-banner d-flex flex-column justify-content-center align-items-center text-center"
  role="dialog"
  aria-labelledby="cookie-message"
  tabindex="0"
>
  <p id="cookie-message" class="text-white">
    🍪 Ce site utilise des cookies pour améliorer votre expérience.
    En continuant, vous acceptez notre
    <NuxtLink to="/privacy" class="clean-link">politique de confidentialité</NuxtLink>
    et nos
    <NuxtLink to="/terms" class="clean-link">conditions d’utilisation</NuxtLink>.
  </p>

  <div class="buttons d-flex flex-column flex-md-row gap-2 mt-3 w-100 justify-content-center">
    <button @click="acceptCookies" class="btn btn-success w-100 w-md-auto">Accepter</button>
    <button @click="declineCookies" class="btn btn-danger w-100 w-md-auto">Refuser</button>
  </div>
</div>

  </ClientOnly>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useCookieConsentStore } from '@/composables/useCookieConsentStore'

// 💾 Store de gestion centralisée
const {
  cookieConsent,
  cookiesSet,
  acceptCookies,
  declineCookies,
  resetConsent,
} = useCookieConsentStore()
watchEffect(() => {
  if (!cookiesSet.value) {
    console.log("Consent reset → bannière réaffichée")
  }
})

// 👀 Bouton de préférences cookies (affiché quand footer visible)
const showEditButton = ref(false)

onMounted(() => {
  const footer = document.querySelector('footer')
  if (!footer) return

  const observer = new IntersectionObserver(
    ([entry]) => {
      showEditButton.value = entry.isIntersecting
    },
    { threshold: 0.1 }
  )
  observer.observe(footer)
})
</script>


<style scoped>
/*.cookie-banner {
  position: fixed;
  bottom: 20px;
  left: 20px;
  right: 20px;
  background-color: #1c1c1c; 
  color: #fff; 
  padding: 20px;
  border-radius: 10px;
  z-index: 9999;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  animation: fadeIn 0.5s ease-out;
  font-size: 0.95rem;
  line-height: 1.6;
   max-width: 720px; 
  margin: 0 auto;    
}

.cookie-banner p {
  margin: 0;
  flex: 1 1 300px; 
  color: #fff; 
}

.clean-link {
  display: inline-block;
  margin: 0 4px;
  color: #ffcc70;
  font-weight: bold;
  text-decoration: underline;
}
.clean-link:hover {
  color: #ffc107;
  text-decoration: none;
}

.buttons {
  display: flex;
  gap: 10px;
  margin-left: 20px;
  flex-shrink: 0;
  margin-top: 10px;
}


button {
  padding: 10px 16px;
  font-weight: 600;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: background 0.3s ease;
}

.btn-success {
  background: #28a745;
  color: #fff;
}
.btn-success:hover {
  background: #218838;
}

.btn-danger {
  background: #dc3545;
  color: #fff;
}
.btn-danger:hover {
  background: #c82333;
}
.cookie-edit {
  position: fixed;
  bottom: 90px; 
left: 20px;
  z-index: 9998;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 6px;
  padding: 6px 12px;
  font-size: 0.9rem;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
}



.btn-reset {
  background: #fff;
  color: #333;
  font-weight: bold;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 8px 12px;
  cursor: pointer;
  font-size: 0.85rem;
}
.btn-reset:hover {
  background: #f3f3f3;
}


@media (max-width: 768px) {
  .cookie-banner {
    flex-direction: column;
    align-items: stretch;
    text-align: center;
    padding: 16px 12px;
    max-width: 90vw; 
  }

  .buttons {
    margin: 15px 0 0;
    justify-content: center;
  }

  .cookie-edit {
    left: 10px;
    right: auto;
    bottom: 80px;
    text-align: center;
  }
}
@media (max-width: 450px) {
  .cookie-banner {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 16px 12px;
    font-size: 0.85rem;
    bottom: 10px;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 100%;            
    max-width: 100vw;       
    box-sizing: border-box;
    max-height: 90vh;
    overflow-y: auto;
  }

  .cookie-banner p {
    font-size: 0.85rem;
    line-height: 1.5;
    margin-bottom: 16px;
    width: 100%;
    word-wrap: break-word;   
  }

  .buttons {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
    padding: 0;
    align-items: center;
  }

  .buttons button {
    width: 100%;
    max-width: 260px;
    font-size: 0.9rem;
    padding: 10px 14px;
  }
}



@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}*/
.cookie-banner {
  position: fixed;
  bottom: 20px;
  left: 0;
  right: 0;
  margin: 0 auto;
  background-color: #1c1c1c;
  color: #fff;
  padding: 20px;
  border-radius: 10px;
  z-index: 9999;
  max-width: 720px;
  width: calc(100% - 40px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
  animation: fadeIn 0.5s ease-out;
  font-size: 0.95rem;
  line-height: 1.6;
}
.clean-link {
  color: #ffcc70; /* ✅ bonne lisibilité */
  font-weight: bold;
  text-decoration: underline; /* ✅ soulignement explicite */
}
.clean-link:hover {
  color: #ffc107;
  text-decoration: none;
}
.cookie-banner p {
  margin: 0;
  width: 100%;
}

.buttons {
  width: 100%;
}

</style>
